import React from 'react';

const socialInstagram = require('images/admin/campaign_wrap_up/amplification/social-ig.png');
const socialFacebook = require('images/admin/campaign_wrap_up/amplification/social-fb.png');
const socialPinterest = require('images/admin/campaign_wrap_up/amplification/social-pinterest.png');
const paidFacebook = require('images/admin/campaign_wrap_up/amplification/paid-fb.png');
const paidInstagram = require('images/admin/campaign_wrap_up/amplification/paid-ig.png');

function Amplification(props) {
    const {bgColor, topImages, renderForPdf, getAssetPath} = props;

    return (
        <div className="amplification wrap-up-section">
            <div className="amplification-header-container">
                <div className="amplification-header-title">Amplification</div>
                <div className="amplification-header-subtitle">
                    What can you do with this content?
                </div>
            </div>
            <div className="amplification-body">
                <div className="amplification-social-media">
                    <div className="body-title">Social Media</div>
                    <div className="body-subtitle">
                        {
                            'Fuel social media with authentic content built to look native on the channel.'
                        }
                    </div>
                    <div className="social-media-imgs">
                        <div className="social-instagram social-img">
                            <div className="social-media-img-1" />
                        </div>
                        <div className="social-facebook social-img">
                            <div className="social-media-img-2" />
                        </div>
                        <div className="social-pinterest social-img">
                            <div className="social-media-img-3" />
                        </div>
                    </div>
                </div>
                <div className="amplification-paid-media">
                    <div className="body-title">Paid Media</div>
                    <div className="body-subtitle">
                        Increase conversion by up to
                        <span className="multiplier-span">4x</span>
                        by using Social Native content on paid media.
                    </div>
                    <div className="paid-media-imgs">
                        <div className="paid-facebook social-img">
                            <div className="paid-media-img-1" />
                        </div>
                        <div className="paid-instagram social-img">
                            <div className="paid-media-img-2" />
                        </div>
                    </div>
                </div>
            </div>

            {/*STYLES*/}

            <style>{`
            .amplification {
                background-color: ${bgColor};
                padding-bottom: 40px;
                }

                .amplification-header-title {
                font-size: 36px;
                font-weight: 200;
                padding-top: 40px;
                }

                .amplification-header-subtitle {
                width: 85%;
                font-size: 20px;
                font-weight: 200;
                text-align: center;
                padding: 10px 0px 40px 0px;
                }

                .body-title {
                font-size: 24px;
                font-weight: 200;
                }

                .body-subtitle {
                font-size: 16px;
                font-weight: 100;
                }

                .multiplier-span {
                font-size: 18px;
                font-family: 'Open Sans';
                font-weight: bold;
                }

                .amplification-social-media {
                padding-bottom: 40px;
                width: 100%;
                }

                .social-media-imgs {
                width: 100%;
                }

                .social-img {
                position: relative;
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
                margin: 40px;
                box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.2);
                }

                .social-instagram {
                height: 470px;
                width: 272px;
                background-image: url(${getAssetPath(socialInstagram)});
                }

                .social-facebook {
                height: 470px;
                width: 272px;
                background-image: url(${getAssetPath(socialFacebook)});
                }

                .social-pinterest {
                height: 470px;
                width: 272px;
                background-image: url(${getAssetPath(socialPinterest)});
                }

                .amplification-paid-media {
                width: 100%;
                }

                .paid-media-imgs {
                width: 100%;
                }

                .paid-facebook {
                height: 557px;
                width: 502px;
                background-image: url(${getAssetPath(paidFacebook)});
                }

                .paid-instagram {
                height: 557px;
                width: 321px;
                background-image: url(${getAssetPath(paidInstagram)});
                }

                .social-media-img-1 {
                position: relative;
                top: 70px;
                width: 272px;
                height: 273px;
                background: url(${topImages[0].thumbnail_url}) no-repeat;
                background-size: cover;
                background-position: center;
                }

                .social-media-img-2 {
                position: relative;
                top: 164px;
                width: 272px;
                height: 182px;
                background: url(${topImages[1].thumbnail_url}) no-repeat;
                background-size: cover;
                }

                .social-media-img-3 {
                position: relative;
                top: 29px;
                left: 11px;
                width: 250px;
                height: 360px;
                border-radius: 9px;
                background: url(${topImages[2].thumbnail_url}) no-repeat;
                background-size: cover;
                background-position: center;
                }

                .paid-media-img-1 {
                position: relative;
                top: 141px;
                left: 15px;
                width: 472px;
                height: 247px;
                background: url(${topImages[3].thumbnail_url}) no-repeat;
                background-size: cover;
                background-position: center;
                }

                .paid-media-img-2 {
                position: relative;
                top: 86px;
                width: 321px;
                height: 286px;
                background: url(${topImages[4].thumbnail_url}) no-repeat;
                background-size: cover;
                background-position: center;
                }
                `}</style>

            {/*STYLE FOR WEB*/}
            {!renderForPdf ? (
                <style>{`
                .amplification-header-container {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                }

                .amplification-body {
                display: flex;
                flex-direction: column;
                align-items: center;
                }

                .amplification-social-media {
                display: flex;
                flex-direction: column;
                align-items: center;
                }

                .social-media-imgs {
                display: flex;
                justify-content: center;
                flex-wrap: wrap;
                }

                .amplification-paid-media {
                display: flex;
                flex-direction: column;
                align-items: center;
                }

                .paid-media-imgs {
                display: flex;
                justify-content: center;
                flex-wrap: wrap;
                }
                `}</style>
            ) : null}

            {/*STYLE FOR PDF*/}
            {renderForPdf ? (
                <style>{`
                .amplification {
                page-break-before: always;
                padding: 20px 0px 0px;
                }

                .amplification-header-container {
                text-align: center;
                }

                .amplification-header-subtitle {
                margin: auto;
                padding: 10px 0px;
                }

                .amplification-body {
                text-align: center;
                }

                .amplification-social-media {
                padding: 20px 0;
                }

                .social-media-imgs {
                }

                .amplification-paid-media {
                }

                .paid-media-imgs {
                }

                .social-img {
                display: inline-block;
                vertical-align: top;
                margin: 20px;
                }
                `}</style>
            ) : null}
        </div>
    );
}

Amplification.propTypes = {};

export default Amplification;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/amplification/index.js